import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import 'element-remove'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import Apollo from 'app/Apollo'
import Theme from 'app/Theme'
import history from 'app/history'
import ReactWidgetErrorBoundary from '../ReactWidgetErrorBoundary'
import ContactUsButton from 'components/ContactUsButton/ContactUsButton'

// разместить этот элемент в том месте страницы, где нужен виджет
// <div id="contact_us_button">
// <script type="text/javascript" src="/sports/scripts/react-widgets/contact_us_button.js?1"></script>

// получаем элемент
const element = document.getElementById('contact_us_button');

if (element) {

  // рендер виджета в указанный элемент
  // Apollo и Theme обязетнльны для создания необходимых контекстов
  // если нужны другие контексты, добавьте их сюда же внутри темы, обернув в них свой компонент
  ReactDOM.render(
    (
      <ReactWidgetErrorBoundary>
        <Apollo>
          <Router {...{history}}>
            <Theme>
              <ContactUsButton />
            </Theme>
          </Router>
        </Apollo>
      </ReactWidgetErrorBoundary>
    ),
    element
  )
}
